import { useEffect, useState } from 'react'
import { subscribeToLeads } from '../repository/leadsRepository'
import type { Lead } from '@/types/crm'

interface LeadsState {
  leads: Lead[]
  loading: boolean
  error: string | null
}

/** Live list of every lead in the pipeline. */
export function useLeads(): LeadsState {
  const [state, setState] = useState<LeadsState>({ leads: [], loading: true, error: null })

  useEffect(() => {
    return subscribeToLeads(
      (leads) => setState({ leads, loading: false, error: null }),
      (error) => setState({ leads: [], loading: false, error: error.message }),
    )
  }, [])

  return state
}
